import { COMMON } from "../../../util/localizations";

const TRANSLATIONS = {
    en: {
        
        noDataBody: "Mint a board or buy one!",
        noDataTitle: "You don't own any NFTs!",
        notConnectedTitle: COMMON.en.notConnectedTitle,
        notConnectedBody: COMMON.en.notConnectedBody,
        subtitle: `All ${ COMMON.appName } NFTs belonging to the address, "{0}".`,
        title: COMMON.en.collection,
        tokenHistory: COMMON.en.tokenHistory,
        transferBoard: COMMON.en.transferBoard,
        viewBoard: 'View Board'
    }
}

export default TRANSLATIONS